export enum ToolMapActionType {
  ZoomIn,
  ZoomOut,
  InitialViewpoint,
  PreviousViewpoint,
  NextViewpoint,
  Clear,
  Screenshot,
}
